import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Footer } from 'site-modules/shared/components/footer/footer';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { SpaLinks } from 'site-modules/shared/components/spa-links/spa-links';
import { ExperimentsPanel } from 'site-modules/shared/components/experiment/panel/experiments-panel';
import { ClientSideRender } from 'site-modules/shared/components/client-side-render/client-side-render';
import { ErrorBoundary } from 'site-modules/shared/components/error-boundary/error-boundary';
import { ErrorPageMessage } from 'site-modules/shared/components/error-page-message/error-page-message';
import { SEOHead } from 'site-modules/shared/pages/seo';

export class EdmundsNoGlobalNavNoAd extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    skipFloodlight: PropTypes.bool,
  };

  static defaultProps = {
    skipFloodlight: false,
  };

  render() {
    return (
      <div className="edm-page no-global-nav">
        <ErrorBoundary>
          <SEOHead {...this.props} />
        </ErrorBoundary>
        <ErrorBoundary>
          <FeatureFlag name="testSpa">
            <SpaLinks />
          </FeatureFlag>
        </ErrorBoundary>
        <ErrorBoundary Fallback={ErrorPageMessage}>{this.props.children}</ErrorBoundary>
        <ErrorBoundary>
          <Footer />
        </ErrorBoundary>
        <ErrorBoundary>
          <ClientSideRender>
            <ExperimentsPanel />
          </ClientSideRender>
        </ErrorBoundary>
      </div>
    );
  }
}
